var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"duplicate-contact-text"},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")]),_c('OverviewModalFooter',{attrs:{"success":false,"waiting":false,"isSaveModal":true,"primaryButtonName":"Ok"},on:{"handleClick":_vm.handleClose,"close":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }